import RaiseFunds from './index';

export default {
    path: '/home/raiseFunds',
    component: RaiseFunds,
    children: []
}